import { render, staticRenderFns } from "./package-details.vue?vue&type=template&id=1caba7a4&scoped=true"
import script from "./package-details.vue?vue&type=script&lang=js"
export * from "./package-details.vue?vue&type=script&lang=js"
import style0 from "./package-details.vue?vue&type=style&index=0&id=1caba7a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caba7a4",
  null
  
)

export default component.exports